var map = {
	"./img_1.png": 24608,
	"./img_10.png": 39200,
	"./img_11.png": 56496,
	"./img_12.png": 37072,
	"./img_13.png": 54239,
	"./img_14.png": 96097,
	"./img_15.png": 75739,
	"./img_2.png": 32913,
	"./img_3.png": 63627,
	"./img_4.png": 33854,
	"./img_5.png": 82931,
	"./img_6.png": 51555,
	"./img_7.png": 44388,
	"./img_8.png": 43547,
	"./img_9.png": 28333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46721;